import * as z from 'zod'
import { DriverRegistrationRequest } from '~/shared/api'

export const formSchema = DriverRegistrationRequest.schema.pick({
  citizenship: true,
  passportNumber: true,
  birthDate: true,
  passportIssueDate: true,
  registrationAddress: true,
  divisionCode: true,
  passportIssued: true,
  passportPhotos: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = SchemaType
